let route = {
    path: '/modules/logistics',
    name: 'logistics',
    component: () => import('@/modules/logistics/index.vue'),
    children: [
        {
            path: 'manage',
            name: 'Logistics-Manage',
            component: () => import('@/modules/logistics/manage/index.vue'),
            meta: {
                pageTitle: '物流商管理',
            }
        },
        {
            path: 'manage/edit',
            name: 'Logistics-Manage-Edit',
            component: () => import('@/modules/logistics/manage/edit.vue'),
            meta: {
                parent: '/modules/logistics/manage',
            }
        },
        {
            path: 'cost-template',
            name: 'Logistics-Cost-Template',
            component: () => import('@/modules/logistics/cost-template/index.vue'),
            meta: {
                pageTitle: '运费模板',
            }
        },
        {
            path: 'cost-template/edit',
            name: 'Logistics-Cost-Template-Edit',
            component: () => import('@/modules/logistics/cost-template/edit.vue'),
            meta: {
                parent: '/modules/logistics/cost-template',
            }
        },
        {
            path: 'follow',
            name: 'Logistics-Follow',
            component: () => import('@/modules/logistics/follow/index.vue'),
            meta: {
                pageTitle: '物流跟踪',
            }
        }
    ]
};
export const LogisticsRoute = route;
